export const LAT_INITIAL = 35.70223;

export const LNG_INITIAL = 51.324606;
